"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.themes = exports["default"] = void 0;
var _reactCssThemr = require("react-css-themr");
var _ModalHeader = _interopRequireDefault(require("./ModalHeader"));
// themes
require("./themes/DefaultTheme.css");
var DefaultTheme = {
  "modal-header": "DefaultTheme__modal-header___3-lo2",
  "danger": "DefaultTheme__danger___2Gh6V",
  "close": "DefaultTheme__close___3T_6-",
  "modalHeader": "DefaultTheme__modal-header___3-lo2"
};
require("./themes/DarkTheme.css");
var DarkTheme = {
  "modal-header": "DarkTheme__modal-header___1_GCa",
  "modalHeader": "DarkTheme__modal-header___1_GCa"
};
require("./themes/LumeTheme.css");
var LumeTheme = {
  "modal-header": "LumeTheme__modal-header___2mmkW",
  "modalHeader": "LumeTheme__modal-header___2mmkW"
};
var themes = exports.themes = {
  DefaultTheme: DefaultTheme,
  DarkTheme: DarkTheme,
  LumeTheme: LumeTheme
};
var ThemedComponent = (0, _reactCssThemr.themr)(_ModalHeader["default"].displayName, themes.DefaultTheme)(_ModalHeader["default"]);
ThemedComponent.displayName = _ModalHeader["default"].displayName;
ThemedComponent.themes = themes;
var _default = exports["default"] = ThemedComponent;
//# sourceMappingURL=index.js.map